export const displayHash = (hash) => {
  return `${hash.substring(0, 8)}...`;
};
